import { Reveal } from "@/components/Reveal";
import { WHO_FOR, INQUIRY_EXAMPLES } from "@/data/academy";
import { Check } from "lucide-react";

export default function WhoForInquiry() {
  return (
    <section className="bg-cream py-28 md:py-44" data-testid="whofor-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-28">
        <div>
          <Reveal>
            <p className="overline text-ochre mb-7">Who it's for</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light leading-tight text-charcoal">
              No formal qualifications required to begin.
            </h2>
            <p className="mt-8 text-charcoal/70 text-lg font-light leading-relaxed">
              The Academy respects existing knowledge and lets participants build from their own
              experience. It serves people who are:
            </p>
          </Reveal>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8">
            {WHO_FOR.map((w, i) => (
              <Reveal key={w} delay={(i % 2) * 0.05}>
                <div className="flex items-start gap-3 py-3 border-b border-charcoal/10">
                  <Check size={16} className="text-eucalyptus mt-1 shrink-0" />
                  <span className="text-charcoal/80 font-light">{w}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div>
          <Reveal>
            <p className="overline text-ochre mb-7">Learning through inquiry</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light leading-tight text-charcoal">
              Become restoration ready.
            </h2>
            <p className="mt-8 text-charcoal/70 text-lg font-light leading-relaxed">
              Develop the capability to collect native seed, establish seed banks, support ecological
              recovery and contribute to Australia's growing restoration economy.
            </p>
            <p className="mt-5 text-charcoal/70 text-lg font-light leading-relaxed">
              Through ecological understanding, hands-on field experience and practical training,
              participants build the confidence and practical skills to collect, process and store
              native seed, support restoration and rehabilitation projects, and develop sustainable
              native seed enterprises.
            </p>
          </Reveal>
          <div className="mt-8">
            {INQUIRY_EXAMPLES.map((e, i) => (
              <Reveal key={e} delay={i * 0.04}>
                <div className="flex items-baseline gap-5 py-4 border-b border-charcoal/10">
                  <span className="font-serif text-ochre">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-charcoal/80 font-light text-lg">{e}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
